import { render } from "./IconLocationSearching.vue?vue&type=template&id=2418ca24"
import script from "./IconLocationSearching.vue?vue&type=script&lang=js"
export * from "./IconLocationSearching.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__